import React from "react";
import {
  horizontal_flower,
  lobby_middborder,
  fluster_lobby_background_large
} from "assets/images/fluster";
import JoinNow from "pages/lobby/joinNow";
import FlusterUsers from "./FlusterUsers";
import FlusterLobbyFooter from "./FlusterLobbyFooter";

const Fluster = ({ onBack, usersChanged, branchLink }) => {
  return (
    <div className="fluster-lobby">
      <img
        src={fluster_lobby_background_large}
        alt="fluster_lobby_background_large"
        className="fluster-lobby-background"
      />
      <div className="fluster-lobby-main-content">
        <div className="left-content">
          <JoinNow
            link={branchLink}
            type="fluster"
            className="fluster-card barcode"
            joinCodeTextClassName="scan-text"
            fluster
          />
        </div>
        <div className="middle-content">
          <img src={lobby_middborder} alt="" />
        </div>
        <div className="right-content">
          <FlusterUsers usersChanged={usersChanged} />
          <div className="flower">
            <img src={horizontal_flower} alt="horizontal_flower" />
          </div>
          <FlusterLobbyFooter onBack={onBack} />
        </div>
      </div>
    </div>
  );
};

export default Fluster;
